import styled from "styled-components";

const GradientWrapper = styled.div.attrs({
  className: "GradientWrapper",
})`
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color: ${(props) => props.theme.colors.green};
  background: ${(props) =>
    props.theme.gradient[props.gradient] || props.theme.colors.blue};
  min-height: 70px;
  gap: 12px;
  width: 100%;
  flex-direction: column;
  padding: ${(props) => props.$padding || "0 16px"};
  margin: ${(props) => props.$margin || "0"};
  * {
    color: ${(props) => props.theme.colors.white} !important;
  }
`;

export default GradientWrapper;
